<template>
	<div class="alert" :class="alertClass">
		<h2>{{ title }}</h2>
		<div class="progress">
			<div class="progress-bar" :style="progressStyle"></div>
		</div>
		<hr>
		<h3 v-if="isDone">All done!</h3>
		<button v-else type="button" class="btn btn-primary" @click="onStep">
			I make step!
		</button>
	</div>
</template>
<script>
	export default {
		props: ['title', 'current', 'max'],
		computed: {
			curMaxRel(){
				return this.current / this.max;
			},
			isDone(){
				return this.curMaxRel == 1;
			},
			progressStyle(){
				return {
					width: (this.curMaxRel * 100) + '%'
				}
			},
			alertClass(){
				return {
					'alert-danger': this.curMaxRel < 0.25,
					'alert-warning': this.curMaxRel >= 0.25 && this.curMaxRel < 0.75,
					'alert-success': this.curMaxRel >= 0.75
				}
			}
		},
		methods: {
			onStep(){
				this.$emit('step');
			}
		}
	}
</script>
<style scoped>
	.alert{
		margin: 40px 0;
	}
</style>